import { MESSAGING } from 'core/datasets/action';
import { isObject } from 'lodash';
import { SetChannelsMap } from 'messaging/types/redux/messagingActions';
import { put } from 'redux-saga/effects';

export function* subscribeToChannelMapMetadata(action: SetChannelsMap): Generator {
    const channelsMap = action?.payload?.channelsMap;

    if (!channelsMap || !isObject(channelsMap)) {
        console.error('Invalid channels map', { channelsMap });
        return;
    }

    for (const channelId in channelsMap) {
        yield put({
            type: MESSAGING.ADD_CHANNEL_KEY,
            payload: channelId,
        });
    }
}
